export const mergeSearchParams = ({ into, from, }) => {
    const mergedRedirectUrl = new URL(into);
    const search = new URLSearchParams(from);
    search.forEach((val, key) => {
        mergedRedirectUrl.searchParams.append(key, val);
    });
    return mergedRedirectUrl.toString();
};
//# sourceMappingURL=mergeSearchParams.js.map